import React, { useEffect, useRef } from 'react';

import {
  useGlobalStateContext,
  useGlobalDispatchContext,
} from "../../context/globalContext"

const Container: React.FC<any> = ({ children, innerRef, cursorColor, ...rest }) => {
  const elemRef = useRef(null);
  const dispatch = useGlobalDispatchContext();

  const onMouseEnter = () => {
    dispatch({ type: "CURSOR_COLOR", cursorColor: cursorColor })
  }

  const onMouseLeave = () => {
    dispatch({ type: "CURSOR_COLOR", cursorColor: '#F5F5F5' })
  }

  useEffect(() => {
    if (innerRef && elemRef.current) {
      innerRef(elemRef.current)
    }
  }, []);

  return (
    <div ref={elemRef} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} {...rest}>
      {children}
    </div>
  );
};

export default Container;
